import React, { useState, useEffect } from 'react'
import { Card, Button, Row, Col, Modal, Form, Input, message } from 'antd';
import { API, getData, sendDataBody, updateData, usuario } from '../../resources';
import { PlusOutlined, FormOutlined, PrinterOutlined } from '@ant-design/icons';
const { TextArea } = Input;

export default function Recetas({ id_paciente }) {

    const [recetas, setRecetas] = useState([])

    useEffect(() => {
        getRecetas()
    }, [])

    const getRecetas = () => {
        getData(`recetas/${id_paciente}`).then(setRecetas)
    }
    // Add Recipe Modal
    const [isModalVisible, setIsModalVisible] = useState(false); // Modal For Add REcipe
    const handleOk = () => { setIsModalVisible(false); };
    const handleCancel = () => { setIsModalVisible(false); };

    const onFinish = async (values) => {
        values.id_paciente = id_paciente;
        console.log(values)
        await sendDataBody('recetas/add', values).then(getRecetas)
        setIsModalVisible(false)
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card style={{ marginTop: 8 }}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <h5>Recetas</h5>
                <Button className='btnIconCentered' onClick={() => setIsModalVisible(true)} size='small' type="primary" shape="round" icon={<PlusOutlined />} ghost >Nueva receta</Button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 8 }}>
                {recetas.length === 0 && (
                    <p style={{ color: '#bbb', fontSize: 13, margin: 0 }}>Sin recetas registradas</p>
                )}
                {recetas.map((r, i) => (
                    <div key={i} style={{ padding: '6px 10px', borderLeft: '3px solid #1890ff', background: '#f0f7ff', borderRadius: '0 4px 4px 0', fontSize: 13, lineHeight: 1.5 }}>
                        {r.prescripcion}
                    </div>
                ))}
            </div>

            <Modal title="Nueva Receta" open={isModalVisible} onOk={handleOk} onCancel={handleCancel}
                footer={[
                    <Button type="primary" htmlType="submit" form='create_receta_medic2'>
                        Guardar
                    </Button>,
                    <Button onClick={handleCancel}>Cancelar</Button>
                ]}>
                <Form
                    name="create_receta_medic2"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Prescripcion"
                        name="prescripcion"
                        rules={[{ required: true, message: 'Ingresa la prescripcion' }]}
                    >
                        <TextArea rows={6} autoFocus />
                    </Form.Item>

                </Form>
            </Modal>

        </Card>
    )
}
